import { Images, ServiceImages } from '../types';

// Services Images
const serviceImages: ServiceImages = {
  renovations: 'https://images.unsplash.com/photo-1581235720704-06d3acfcb36f?w=800&h=600&fit=crop',
  newConstruction: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=800&h=600&fit=crop',
  carpentry: 'https://images.unsplash.com/photo-1601058268499-e52658b8bb88?w=800&h=600&fit=crop',
  kitchenRemodeling: 'https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?w=800&h=600&fit=crop',
  bathroomRemodeling: 'https://images.unsplash.com/photo-1584622781564-1d987f7333c1?w=800&h=600&fit=crop',
  outdoorLiving: 'https://images.unsplash.com/photo-1600607686527-6fb886090705?w=800&h=600&fit=crop',
};

// All images with their URLs
const images: Images = {
  heroImage: 'https://images.unsplash.com/photo-1512770961409-3868fd0b3e98?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?w=1920&h=1080&fit=crop',
  featuredProjectImages: [
    // Modern Kitchen Renovation (after)
    'https://images.unsplash.com/photo-1600566752229-250ed79470f8?q=80&w=3478&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    // Custom Deck Construction (after)
    'https://plus.unsplash.com/premium_photo-1671228941105-3b2bf6918fea?q=80&w=3240&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    // Master Bathroom Remodel (after)
    'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop'
  ],
  serviceImages,
  aboutStoryImage: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=800&h=600&fit=crop',
  teamMemberImages: [
    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop', // CEO
    'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=300&h=300&fit=crop', // Project Manager
    'https://images.unsplash.com/photo-1618077360395-f3068be8e001?w=300&h=300&fit=crop', // Lead Carpenter
    'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300&h=300&fit=crop'  // Designer
  ],
  testimonialImages: [
    'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop',
    'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop',
    'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop'
  ]
};

// Export all image URLs
export const {
  heroImage,
  featuredProjectImages,
  aboutStoryImage,
  teamMemberImages,
  testimonialImages,
} = images;

export { serviceImages }; 